import React from 'react';
import css from './index.module.scss';
import { FormattedMessage, useIntl } from 'react-intl';
import { FormControlLabel, Checkbox } from '@material-ui/core';

import lightningPayIcon from '../images/Lightningpay.svg';
import oneClick from './images/OneClick.svg';
import securePayment from './images/SecuredPayments.svg';
import Hasslefreepayment from './images/Hasslefreepayment.svg';
import pathIcon from './images/Path.svg';
import classNames from 'classnames';
import BackButton from '../../../components/BackButton';

const EnableLightningPayModal = ({ sendOrderToMs, confirmLightningPay, onClose, isDesktop }) => {
  const intl = useIntl();
  const handleDonotRemind = (e) => {
    window.localStorage.setItem('l_dnd', 'true');
    sendOrderToMs && sendOrderToMs(e, undefined, false, true);
    onClose && onClose();
  };

  return (
    <div className={css.root}>
      <div className={css.containerModal}>
        <BackButton type="cross" handleBack={onClose} />
      </div>

      <div className={css.bannerContainer}>
        <img src={lightningPayIcon} alt=" lightning Icon" />
      </div>
      <div className={css.titleSection}>
        <FormattedMessage id="lightning_pay_title" />
      </div>
      <span className={css.subHeading}>
        <FormattedMessage id={'click_payment'} defaultMessage="Seamless one click payment" />
      </span>
      <hr className={css.hrLine} />
      <div className={css.container}>
        <div className={css.section}>
          <div className={css.image}>
            <img src={oneClick} alt="One Click" />
          </div>
          <div className={css.content}>
            <h2 className={css.heading}>
              <FormattedMessage id={'one_click'} defaultMessage="One Click" />
            </h2>
            <p className={css.subheading}>
              <FormattedMessage id={'fast_click'} defaultMessage="Fast Click" />
            </p>
          </div>
        </div>
        <div className={css.section}>
          <div className={css.image}>
            <img src={securePayment} alt="Image 2" />
          </div>
          <div className={css.content}>
            <h2 className={css.heading}>
              <FormattedMessage id="secured_payment" />
            </h2>
            <p className={css.subheading}>
              <FormattedMessage id="secure_sensitive" />
            </p>
          </div>
        </div>
        <div className={css.section}>
          <div className={css.image}>
            <img src={Hasslefreepayment} alt="Image 3" />
          </div>
          <div className={classNames(css.content, { [css.hassle]: !isDesktop })}>
            <h2 className={css.heading}>
              <FormattedMessage id="hassle" />
            </h2>
            <p className={css.subheading}>
              <FormattedMessage id="every_purchase" />
            </p>
          </div>
        </div>
      </div>

      <div
        onClick={(e) => {
          sendOrderToMs && sendOrderToMs(e, undefined, true);
          confirmLightningPay && confirmLightningPay();
        }}
        className={css.enableLightingPay}
      >
        <div className={css.title}>
          <FormattedMessage id="yes" />, <FormattedMessage id="lightning_pay_enable_and_pay" />
          <img src={pathIcon} className={css.pathIcon} alt="light" />
        </div>
        <div className={css.description}>
          <FormattedMessage id="lightning_pay_next_transection" />
        </div>
      </div>
      <div className={css.laterSection}>
        <FormControlLabel
          control={<Checkbox onChange={handleDonotRemind} color="primary" name="donotRemind" />}
          label={intl.formatMessage({ id: 'lightning_pay_donot_remind' })}
          className={css.styleCheckbox}
        />
        <div
          onClick={(e) => {
            sendOrderToMs && sendOrderToMs(e, undefined, false, true);
            onClose && onClose();
          }}
          className={css.maybeLaterSection}
        >
          <FormattedMessage id="lightning_pay_later" />
        </div>
      </div>
    </div>
  );
};

export default EnableLightningPayModal;
